export const authTypes = {
  login_start: "[auth] Login start",
  login_error: "[auth] Login error",
  login_success: "[auth] Login success",
  logout: "[auth] Logout",
  change_user_info: "[auth] Change user info",
}
